import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import Alert from 'components/common/feedback/alert';
import Link from 'components/common/link';
import useStores from 'hooks/use-stores.hooks';
import { links } from 'constants/external-links';

const ExistingOrganizationAlert: React.FunctionComponent = () => {
  const { organizationsStore } = useStores();

  if (Object.keys(organizationsStore.organizations).length === 0) return null;

  return (
    <AlertContainer>
      <Alert
        type="warning"
        data-e2e="existing-organization-alert"
        message={<FormattedMessage id="organizations.create.form.existing-organization-alert.title" />}
        description={
          <>
            <FormattedMessage id="organizations.create.form.existing-organization-alert.description" />{' '}
            <Link
              messageId="organizations.create.form.existing-organization-alert.link"
              url={links.docs.PROJECTS.ADMIN_GUIDE}
            />
          </>
        }
      />
    </AlertContainer>
  );
};

const AlertContainer = styled.div`
  margin-bottom: var(--spacing-lg);
`;

export default observer(ExistingOrganizationAlert);
